import {useState, useEffect, useRef} from 'react';
import { useNavigate } from 'react-router-dom';
import Box from '@mui/material/Box';
import mapboxgl from 'mapbox-gl';
import ReactDOM from 'react-dom/client';

import Loading from '../../common/Loading';
import Error from '../../common/Error';
import LoadListMapSpatialPopup from './LoadListMapSpatialPopup';

export default function LoadListMap( props ) {
    //console.debug("RTS Break LoadListMapSpatial");

    const history = useNavigate();

    const [isLoading, setIsLoading] = useState(true);
    const [hasError, setHasError] = useState(false);

    const map = useRef(null);

    useEffect(() => {
        if(map.current) return;

        map.current = new mapboxgl.Map({
            container: "mapContainer",
            accessToken: "pk.eyJ1IjoiamltcHRhayIsImEiOiJja3kzMXZyOHIwNnRvMnBwOGxrbWJ4ZDhiIn0.bWHzm3g7ZOvo1wcWf2w8fg",
            style: "mapbox://styles/mapbox/streets-v11",
            center: [-85.0716746, 33.5666694],
            zoom: 9
        });
    });

    
    useEffect(() => {
        if(!map.current) return;

        setIsLoading(true);
        
        var maxLng = 0, maxLat = 0, minLng = 0, minLat = 0, markerCount = 0;

        props.data.map((ld, idx) => {
            if(ld.curLat != null && ld.curLng != null){
                const coord = {lat:ld.curLat, lng:ld.curLng};
                markerCount = ld.childIdx;

                if (markerCount === 1) {
                    minLng = maxLng = ld.curLng // longitude
                    minLat = maxLat = ld.curLat; // latitude
                }
                else {
                    maxLng = ld.curLng > maxLng ? ld.curLng : maxLng;
                    minLng = ld.curLng < minLng ? ld.curLng : minLng;
                    maxLat = ld.curLat  > maxLat ? ld.curLat  : maxLat;
                    minLat = ld.curLat  < minLat ? ld.curLat  : minLat;
                }

                const elMarker = document.createElement('div');

                if(ld.curTrackerESN !== null){
                    if(ld.deferralDaysLeft < 30){
                        elMarker.className = "rtsTrackerMarkerRed";
                    }
                    else if (ld.deferralDaysLeft < 60){
                        elMarker.className = "rtsTrackerMarkerOrange";
                    }
                    else if (ld.deferralDaysLeft < 90){
                        elMarker.className = "rtsTrackerMarkerGold";
                    }
                    else{
                        elMarker.className = "rtsTrackerMarkerGreen";
                    }
                }
                else{
                    elMarker.className = "rtsMarker rtsDarkBackground";
                }
                const elNum = document.createElement('span');
                elNum.className = "rtsLightForeground";
                elNum.innerHTML = markerCount;
                elMarker.appendChild(elNum)

                let marker = new mapboxgl.Marker(elMarker)
                    .setLngLat(coord)
                    .addTo(map.current);



                const popupNode = document.createElement('div');
                const root = ReactDOM.createRoot(popupNode);

                marker.setPopup(
                    new mapboxgl.Popup().setDOMContent(popupNode)
                );

                marker.getElement().addEventListener('click', () => {
                    // Render the React component inside the popup
                    root.render(<LoadListMapSpatialPopup onItemClick={handlePopupClick} data={ld} />);
                });
            }

            return null;
        });

        var sw = new mapboxgl.LngLat(minLng, minLat);
        var ne = new mapboxgl.LngLat(maxLng, maxLat);
        var llb = new mapboxgl.LngLatBounds(sw, ne);

        if(markerCount > 0){
            if(markerCount === 1){
                map.current.setCenter(sw);
            }
            else{
                map.current.fitBounds(llb,
                    {
                        padding: { top: 50, bottom: 50, left: 50, right: 50 } ,
                        animate: false
                    }
                );   
            }
        }
        
        setIsLoading(false);

    }); 
    
    
    useEffect(() => {
        if(!map.current) return;
        map.current.resize();
    },[props]);    
    

    // Function to be passed into the popup component
    const handlePopupClick = (idGuid) => {
        history("/LoadListDetails", {state: {idGuid:idGuid}});
    };


     if(hasError){
        return(
            <Error />
        );
    }



    return(
        <>
        <Box sx={{display:isLoading===true?'block':'none', zIndex:'12000'}}>
            <Loading />
        </Box>
        <Box id="mapContainer" sx={{width:'100%', height:'100%'}} ></Box>
        </>
    );
}
